import React from 'react';

import PasswordInputComponent from 'common/components/PasswordInput';

export default class PasswordInput extends React.Component {
  render() {
    return <PasswordInputComponent {...this.props} />;
  }
}
